export default __webpack_public_path__ + "static/media/waiting-times-desktop.3c67f036.png";